// External
import axios from "axios";
import moment from "moment";
import Modal from "react-modal";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector, useDispatch } from "react-redux";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { AES } from 'crypto-js';
import { useQueryClient } from "react-query";
import { removeInvoiceFromCache } from "../services.js";
import { Parser } from "html-to-react";
import userCategoryName from "../../../constants/userCategory";
// External

// Internal
import css from "./Invoicesingle.css";
import InvoiceActions from "./InvoiceActions";
import WXCompany from "../elements/wxCompany.jsx";
import InvoiceAddress from "./elements/InvoiceAddress";
import ItemDescription from "./elements/ItemDescription";
import { INVOICE_STATUS } from "../../../constants/invoice.js";
import userTypeConsts from "../../../constants/userTypeConsts";
import { logout, reset } from "../../../features/auth/authSlice";
import wiseImage from "../../../images/singleinvoice/wise-logo.svg";
import { setHeaderText } from "../../../features/headerText/headerTextSlice";
import { reset as invoiceReset } from "../../../features/invoice/invoiceSlice.js";
import { setNotification } from "../../../features/notification/notificationSlice.js";
import PaymentStatusWiseSingle from "../../Invoices/elements/paymentStatusWiseSingle";
import { reset as headerReset } from "../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset, setAppLoading } from "../../../features/appSettings/appSettingsSlice.js";
import { getBankFromCompany, getUserInvoice, bankDetail } from "./services/invoiceSingle.js";
// Internal
const TikIcon = () => <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 4.5L5 8.5L12.5 1" stroke="#7CC273" strokeWidth="1.5"/></svg>;
const CrssrIcon = () => <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.41895 12L11.9189 1.5" stroke="#FE6161" strokeWidth="1.5"/><path d="M1.41895 1.5L11.9189 12" stroke="#FE6161" strokeWidth="1.5"/></svg>;

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
  },
};

function getFileExtension(filename) {
  const lastIndex = filename.lastIndexOf(".");
  if (lastIndex !== -1) {
    return filename.slice(lastIndex + 1);
  }
  return "";
}

const InvoiceSingle = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [invStatus, setInvStatus] = useState("");
  const [invoiceUserId, setInvoiceUserId] = useState(null);
  const [invoiceView, setInvoiceView] = useState([]);
  const [invoiceData, setInvoiceData] = useState(null);
  const [userWiseProfile, setUserWiseProfile] = useState(null);
  const [isLoadingReject, setIsLoadingReject] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [isLoadingPayment, setIsLoadingPayment] = useState(false);
  const [isLoadingApprove, setIsLoadingApprove] = useState(false);
  const [manualModalIsOpen, setManualModalIsOpen] = useState(false);
  const [isLoadingManualPayment, setIsLoadingManualPayment] = useState(false);
  const [wiseSelected, setWiseSelected] = useState("");
  const [bankDetails, setBankDetails] = useState(null);
  const [bankDetailsLoaded, setBankDetailsLoaded] = useState(false);
  const [wxCompany, setWxCompany] = useState(null);
  const [wiseEmail, setWiseEmail] = useState(null);
  const [invBank, setInvBank] = useState(null);
  const [invBankLabel, setInvBankLabel] = useState(null);
  const [wxUserCompany, setWxUserCompany] = useState(null);
  const [wxCompanyDropdownOpen, setWxCompanyDropdownOpen] = useState(false);
  const [wxCompanyBankDropdownOpen, setWxCompanyBankDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth <= 991);
  const [statusAccordionOpen, setStatusAccordionOpen] = useState(false);
  const [paymentAccordionOpen, setPaymentAccordionOpen] = useState(false);
  const [recipientAccordionOpen, setRecipientAccordionOpen] = useState(false);
  const [expandedLineItems, setExpandedLineItems] = useState({});
  const [mobileOptionsModalOpen, setMobileOptionsModalOpen] = useState(false);
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState("");
  const [isCreatingPdf, setIsCreatingPdf] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  const user = useSelector((state) => state.auth.user);
  let token = null;
  if (user) {
    if (user && user.token) {
      token = user.token;
    }
  }

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleEditInvoice = () => {
    setMobileOptionsModalOpen(false);
    if (invoiceData) {
      const encryptedId = AES.encrypt(invoiceData._id, 'encryptionKey').toString();
      const encodedId = encodeURIComponent(encryptedId).replace(/\//g, '%2F');
      if (invoiceData.is_automatic_inv) {
        navigate(`/user/invoice/autoedit/${encodedId}`);
      } else {
        navigate(`/user/invoice/edit/${encodedId}`);
      }
    }
  };

  const handleDownloadPdf = async (e) => {
    if (e) e.preventDefault();
    if (isCreatingPdf) return;
    setIsCreatingPdf(true);
    try {
      await axios.post(`/api/invoice/create`, invoiceView, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const response = await axios.get(`/api/invoice/download/created/pdf`, {
        responseType: "blob",
        headers: { Authorization: `Bearer ${token}` },
      });
      const filename = `${invoiceData?.inv_number || 'invoice'}.pdf`;
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      saveAs(pdfBlob, filename);
      toast.success(`Invoice "${invoiceData?.inv_number}" downloaded successfully!`, {
        position: "bottom-right",
        autoClose: 1500,
      });
      setMobileOptionsModalOpen(false);
    } catch (error) {
      console.error(error);
      toast.error("Failed to download PDF.");
    } finally {
      setIsCreatingPdf(false);
    }
  };

  const handleDeleteInvoiceMobile = () => {
    setMobileOptionsModalOpen(false);
    if (invoiceData?._id) {
      setSelectedInvoiceId(invoiceData._id);
      setDeleteModalIsOpen(true);
    }
  };

  const handleModalConfirm = async () => {
    try {
      setIsSubmitLoading(true);
      const targetId = selectedInvoiceId || invoiceData?._id;
      await axios.get(`/api/delete/invoice/${targetId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      removeInvoiceFromCache(queryClient, targetId);
      toast.success('Invoice removed successfully!', {
        position: "bottom-right",
        autoClose: 1500,
      });
      navigate("/user/invoices", { state: { fromInvoiceAction: true } });
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    } finally {
      setIsSubmitLoading(false);
    }
    setDeleteModalIsOpen(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { id } = useParams();
  const componentRef = useRef();

  useEffect(() => {
    let mounted = true;
    async function fetchInvoice() {
      try {
        dispatch(setAppLoading(true));
        const data = await getUserInvoice(id, token);
        if (!mounted) return;

        const invoiceDetails = data.inv_description;
        const costs = data.inv_cost;
        const category = data.inv_category;
        const vats = data.inv_tax;
        const prices = data.inv_price;

        const invoiceViewData = invoiceDetails.map((item, index) => ({
          Description: item.trim(),
          Cost: costs[index],
          Category: category[index],
          VAT: vats[index],
          Price: prices[index],
        }));

        setWxUserCompany(data.inv_for?.user_wx_comapny?.wx_company);
        setWiseEmail(data.inv_email);
        setInvBank(data.inv_bank);
        setInvoiceUserId(data.inv_for?._id ?? null);
        setWxCompany(data.inv_company_name);
        setWiseSelected(data.inv_bank_profile);
        setInvoiceView([{ ...data, Invoice_Details: invoiceViewData }]);
        setInvoiceData(data);
      } catch (error) {
        if (!mounted) return;
        console.log(error);
        global.config.slackMessage(error.toString());
        if (error.response?.data?.status === "deleted") {
          localStorage.removeItem("user");
          dispatch(logout());
          dispatch(reset());
          dispatch(invoiceReset());
          dispatch(headerReset());
          dispatch(appSettingsReset());
          toast.error("This user is deleted!", {
            position: "bottom-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate("/");
          return;
        }
        alert("Something went wrong");
      } finally {
        if (mounted) {
          dispatch(setAppLoading(false));
        }
      }
    }

    fetchInvoice();
    dispatch(setHeaderText("Invoices"));
    return () => {
      mounted = false;
      dispatch(setAppLoading(false));
    };
  }, [id, invStatus, dispatch, token, navigate]);

  useEffect(() => {
    if (!invoiceData) return;
    let mounted = true;
    async function fetchBankDetails() {
      try {
        const data = await bankDetail(invoiceData, token);
        if (!mounted) return;
        setBankDetails(data || null);
        setBankDetailsLoaded(true);
        setInvBankLabel(data?.accountSummary ?? null);
      } catch (error) {
        if (!mounted) return;
        setBankDetailsLoaded(true);
        console.log(error);
      }
    }
    fetchBankDetails();
    return () => { mounted = false; };
  }, [invoiceData, token, wxUserCompany]);

  useEffect(() => {
    if (!invoiceUserId) return;
    let mounted = true;
    const getUserWiseProfile = async () => {
      try {
        const response = await axios.post(
          "/api/wise/user-wise-profile",
          { userId: `${invoiceUserId}` },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (!mounted) return;
        setUserWiseProfile(response?.data?.id);
      } catch (error) {
        if (!mounted) return;
        console.error("Error fetching user wise profile", error);
      }
    };
    getUserWiseProfile();
    return () => { mounted = false; };
  }, [invoiceUserId, wxCompany, token]);

  const handleToggleDropdown = () => {
    setWxCompanyDropdownOpen(!wxCompanyDropdownOpen);
  };

  const handleBankToggleDropdown = () => {
    setWxCompanyBankDropdownOpen(!wxCompanyBankDropdownOpen);

  };

  const handleSelectCompany = (company) => {
    setWxCompany(company);
    setInvBank(null);
    setInvBankLabel(null);
    setWxCompanyDropdownOpen(false);
    setWxCompanyBankDropdownOpen(false);
  };



  const invoiceStatusApprove = async () => {
    try {
      setIsLoadingApprove(true);

      // Perform the approval request using async/await
      const response = await axios.get(
        `/api/invoice/approve/${id}?company=${wxCompany}&invbank=${invBank}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Dispatch notification after approval
      dispatch(setNotification(Date.now()));

      // Update the invoice status locally in the UI
      setInvoiceView((prevState) => {
        return prevState.map((item) => {
          if (item._id === id) {
            return { ...item, inv_status: "1" };
          }
          return item;
        });
      });
      setInvoiceData((prev) => (prev ? { ...prev, inv_status: 1 } : prev));

      setIsLoadingApprove(false);
      closeModal();
      setInvStatus("Approved");

      // Show success toast
      toast.success("Approved successfully!", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } catch (error) {
      // Handle different error cases
      global.config.slackMessage(error.toString());

      if (error.response?.data?.status === "mailfailed") {
        // Update the invoice status locally in case of mail failure
        setInvoiceView((prevState) => {
          return prevState.map((item) => {
            if (item._id === id) {
              return { ...item, inv_status: "1" };
            }
            return item;
          });
        });
        setInvoiceData((prev) => (prev ? { ...prev, inv_status: 1 } : prev));

        setIsLoadingApprove(false);
        closeModal();
        setInvStatus("Approved");

        // Show error toast for mail failure
        toast.error("Invoice approved successfully, but something went wrong with sending the mail!", {
          position: "bottom-right",
          autoClose: 3500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        console.log(error.response?.data?.message);
      } else {
        // Generic error toast
        toast.error("Something went wrong during approval!");
        console.log(error);
      }
    }
  };


  const invoiceStatusReject = async () => {
    try {
      setIsLoadingReject(true);

      // Perform the rejection request using async/await
      await axios.get(`/api/invoice/reject/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Dispatch notification after rejection
      dispatch(setNotification(Date.now()));

      // Log activity
      global.config.activityLog(window.location.href, 'Invoice', `Invoice rejected successfully.`);

      // Update the invoice status locally in the UI
      setInvoiceView((prevState) => {
        return prevState.map((item) => {
          if (item._id === id) {
            return { ...item, inv_status: "2" };
          }
          return item;
        });
      });
      setInvoiceData((prev) => (prev ? { ...prev, inv_status: 2 } : prev));

      setInvStatus("Rejected");
      setIsLoadingReject(false);
      closeRejectModal();

      // Show success toast
      toast.success("Rejected successfully!", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } catch (error) {
      // Handle different error cases
      global.config.slackMessage(error.toString());

      if (error.response?.data?.status === "mailfailed") {
        // Update the invoice status locally in case of mail failure
        setInvoiceView((prevState) => {
          return prevState.map((item) => {
            if (item._id === id) {
              return { ...item, inv_status: "2" };
            }
            return item;
          });
        });
        setInvoiceData((prev) => (prev ? { ...prev, inv_status: 2 } : prev));

        setInvStatus("Rejected");
        setIsLoadingReject(false);
        closeRejectModal();

        // Show error toast for mail failure
        toast.error("Invoice rejected successfully, but something went wrong with sending the mail!", {
          position: "bottom-right",
          autoClose: 3500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        console.log(error.response?.data?.message);
      } else {
        // Generic error toast
        toast.error("Something went wrong during rejection!");
        console.log(error);
      }
    }
  };


  const createPdf = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`/api/invoice/create`, invoiceView, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const res = await axios.get(`/api/invoice/download/created/pdf`, {
        responseType: "blob",
        headers: { Authorization: `Bearer ${token}` },
      });
      const pdfBlob = new Blob([res.data], { type: "application/pdf" });
      saveAs(pdfBlob, "InvoiceDocument.pdf");
      global.config.activityLog(window.location.href, "Invoice", "Invoice Pdf file Created.");
    } catch (error) {
      console.error("Error creating PDF:", error);
      global.config.slackMessage(error.toString());
      toast.error("Something went wrong while creating the PDF.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const downloadInvDoc = async (invFile) => {
    try {
      // URL encode the filename to handle spaces and special characters
      const encodedFilename = encodeURIComponent(invFile);
      const response = await axios.get(`/api/invoice/download/${encodedFilename}`, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      saveAs(pdfBlob, `${invFile}`);
    } catch (error) {
      console.error(error);
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error("This user is deleted!", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      // Handle error
    }
  };


  const makePayment = async (
    sourceCurrency,
    targetCurrency,
    targetAmount,
    profile,
    recipientId,
    invoiceId,
    company
  ) => {
    setIsLoadingPayment(true);
    const paymentData = {
      sourceCurrency: sourceCurrency,
      targetCurrency: targetCurrency,
      targetAmount: targetAmount,
      profile: profile,
      recipientId: recipientId,
      invoiceId: invoiceId,
      company: company,
    };

    try {
      const response = await axios.post("/api/wise/payment", paymentData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = response.data;
      if (data.status !== "Error") {
        global.config.activityLog(window.location.href, 'Invoice', `Invoice ${invoiceId} (automatic) created.`);
        setInvStatus("paymentProcessing");
        setShowPaymentModal(false);
        queryClient.invalidateQueries("invoices");
        toast.success("Payment submitted successfully!", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      toast.error(`Sorry!.${error.message}`, {
        position: "bottom-right",
        autoClose: 4500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      navigate(-1);
    } finally {
      setIsLoadingPayment(false);
    }
  };

  const handleManualPayment = async () => {
    setManualModalIsOpen(true);
  };

  const handleManualModalConfirm = async (invoiceId) => {
    setIsLoadingManualPayment(true);
    const paymentData = {
      invoice_id: invoiceId,
      payment_with: "manual_payment",
      bank_details: "manual_payment",
      transaction_id: "manual_payment",
    };
    try {
      const response = await axios.post("/api/user/payment", paymentData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = response.data;
      if (data.status === "Error") {
        toast.error("Something went wrong", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        global.config.activityLog(window.location.href, 'Invoice', `Invoice ${invoiceId} paid manually.`);
        setInvStatus("Payment Processed");
        queryClient.invalidateQueries("invoices");
        setInvoiceData((prev) =>
          prev
            ? {
                ...prev,
                inv_payment_status: INVOICE_STATUS.INVOICE_MANNUAL_PAYMENT,
                inv_paid_date: new Date().toISOString(),
              }
            : prev
        );
        toast.success("Invoice payment status updated successfully", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error("This user is deleted!", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      toast.error(`Sorry!.${error.message}`, {
        position: "bottom-right",
        autoClose: 3500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setIsLoadingManualPayment(false);
      setManualModalIsOpen(false);
    }
  };
  const handleManualModalCancel = () => {
    setManualModalIsOpen(false);
  };

  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalRejectIsOpen, setRejectIsOpen] = useState(false);

  function openModal() {
    setIsOpen(true);
  }
  function openRejectModal() {
    setRejectIsOpen(true);
  }
  function openPaymentModal() {
    setShowPaymentModal(true);
  }
  function closeModal() {
    setIsOpen(false);
  }
  function closeRejectModal() {
    setRejectIsOpen(false);
  }
  function closePaymentModal() {
    setShowPaymentModal(false);
  }

  useEffect(() => {
    if (!wiseEmail || !wiseSelected) return;
    let mounted = true;
    async function fetchBank() {
      try {
        const getAllBanks = await getBankFromCompany(wiseSelected, wiseEmail, token);
        if (!mounted) return;
        if (getAllBanks && getAllBanks.length > 0) {
          const filteredBank = getAllBanks.filter(
            (bank) => String(bank.profile) === String(wiseSelected)
          );
          setAllBanks(filteredBank);
        }
      } catch (error) {
        if (!mounted) return;
        console.error("Error fetching banks:", error);
      }
    }
    fetchBank();
    return () => { mounted = false; };
  }, [wiseEmail, wiseSelected]);

  const [allBanks, setAllBanks] = useState([]);

  useEffect(() => {
    if (invoiceData && wxCompany && (wxCompany === "test" || wxCompany === "")) {
      setWxCompany(invoiceData.inv_for?.user_wx_comapny?.wx_company ?? null);
    }
  }, [invoiceData, wxCompany]);

  const wiseProfileChangeHandle = async (wiseProfileId) => {
    setInvBank(null);
    setWiseSelected(null);
    setInvBankLabel(null);
    setWxCompanyBankDropdownOpen(false);
    try {
      const getAllBanks = await getBankFromCompany(wiseProfileId, wiseEmail, token);
      setAllBanks(getAllBanks ?? []);
    } catch (error) {
      console.error("Error fetching banks for profile:", error);
    }
  };

  return (
    <div className="single-ls-info">
      {isMobile ? (
        <div className="mobile-inv-single-wrap">
          {/* Back Navigation Link */}
          <div className="mobile-inv-back-wrap">
            <Link to="/user/invoices" className="mobile-inv-back-link">
              <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 1L1 5L5 9" stroke="#94A3B8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Back to All Invoices</span>
            </Link>
          </div>

          {/* Header + Status + Payment in one section */}
          <div className="mobile-inv-top-section">
            <div className="mobile-inv-header-row">
              <div className="mobile-inv-num-wrap">
                <h2 className="mobile-inv-num">
                  {invoiceData ? (
                    invoiceData.inv_number
                  ) : (
                    <div
                      style={{
                        width: "120px",
                        height: "26px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "6px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  )}
                </h2>
                {(invStatus === "Approved" || invoiceData?.inv_status === 1 || invoiceData?.inv_status === "1" || invoiceData?.inv_status === INVOICE_STATUS.INVOICE_APPROVE) && (
                  <span className="mobile-inv-status-badge approved">Approved</span>
                )}
                {(invStatus === "Rejected" || invoiceData?.inv_status === 2 || invoiceData?.inv_status === "2" || invoiceData?.inv_status === INVOICE_STATUS.INVOICE_REJECT) && (
                  <span className="mobile-inv-status-badge rejected">Rejected</span>
                )}
              </div>
              <div className="mobile-inv-actions-dots" onClick={() => setMobileOptionsModalOpen(true)} style={{ cursor: 'pointer' }}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="4" cy="10" r="1.5" fill="#3B82F6"/>
                  <circle cx="10" cy="10" r="1.5" fill="#3B82F6"/>
                  <circle cx="16" cy="10" r="1.5" fill="#3B82F6"/>
                </svg>
              </div>
            </div>

            <div className="mobile-inv-top-section-inner">
            {/* Accordion 1: Invoice Status */}
            <div className="mobile-inv-card-accordion">
              <div
                className="mobile-inv-accordion-header"
                onClick={() => setStatusAccordionOpen(!statusAccordionOpen)}
              >
                <span className="mobile-inv-accordion-title">Invoice Status</span>
                <span className="mobile-inv-accordion-chevron">
                  <svg
                    width="18"
                    height="9"
                    viewBox="0 0 18 9"
                    fill="none"
                    style={{ transform: statusAccordionOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease' }}
                  >
                    <path d="M1.5 1.5L9 7.5L16.5 1.5" stroke="#405BFF" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
              </div>
              {statusAccordionOpen && (
                <div className="mobile-inv-accordion-body">
                  <div className="mobile-inv-status-btns">
                    {user && (user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN) ? (
                      invoiceData ? (
                        invoiceData.inv_payment_status === INVOICE_STATUS.INVOICE_PAYMENT_NOT_PROCESSING ? (
                          invStatus === "Approved" || invoiceData.inv_status === INVOICE_STATUS.INVOICE_APPROVE || invoiceData.inv_status === 1 || invoiceData.inv_status === "1" ? (
                            <div className="mobile-inv-btn-row">
                              <button type="button" className="mobile-btn-approved" disabled style={{ flex: 1 }}>
                                <span>Approved</span>
                                <TikIcon />
                              </button>
                              <button type="button" className="mobile-btn-reject" onClick={openRejectModal} style={{ flex: 1 }}>
                                <span>Reject</span>
                                <CrssrIcon />
                              </button>
                            </div>
                          ) : invStatus === "Rejected" || invoiceData.inv_status === INVOICE_STATUS.INVOICE_REJECT || invoiceData.inv_status === 2 || invoiceData.inv_status === "2" ? (
                            <div className="mobile-inv-btn-row">
                              <button type="button" className="mobile-btn-approve" onClick={openModal} style={{ flex: 1 }}>
                                <span>Approve</span>
                                <TikIcon />
                              </button>
                              <button type="button" className="mobile-btn-rejected" disabled style={{ flex: 1 }}>
                                <span>Rejected</span>
                                <CrssrIcon />
                              </button>
                            </div>
                          ) : (
                            <div className="mobile-inv-btn-row">
                              <button type="button" className="mobile-btn-approve" onClick={openModal}>
                                <span>Approve</span>
                                <TikIcon />
                              </button>
                              <button type="button" className="mobile-btn-reject" onClick={openRejectModal}>
                                <span>Reject</span>
                                <CrssrIcon />
                              </button>
                            </div>
                          )
                        ) : (
                          <PaymentStatusWiseSingle
                            inv_payment_details={invoiceData._id}
                            invData={invoiceData}
                          />
                        )
                      ) : null
                    ) : (
                      <div className="mobile-inv-btn-row">
                        <div className={`mobile-btn-${(invoiceData?.inv_status === 1 || invoiceData?.inv_status === "1" || invStatus === "Approved") ? 'approved' : (invoiceData?.inv_status === 2 || invoiceData?.inv_status === "2" || invStatus === "Rejected") ? 'rejected' : 'approved'}`} style={{ width: "100%" }}>
                          {(invoiceData?.inv_status === 1 || invoiceData?.inv_status === "1" || invStatus === "Approved") ? "Approved" : (invoiceData?.inv_status === 2 || invoiceData?.inv_status === "2" || invStatus === "Rejected") ? "Rejected" : "Not Reviewed"}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Accordion 2: Payment — only when invoice is approved */}
            {(
              invStatus === "Approved" ||
              invoiceData?.inv_status === INVOICE_STATUS.INVOICE_APPROVE ||
              invoiceData?.inv_status === 1 ||
              invoiceData?.inv_status === "1"
            ) && (
            <div className="mobile-inv-card-accordion">
              <div
                className="mobile-inv-accordion-header"
                onClick={() => setPaymentAccordionOpen(!paymentAccordionOpen)}
              >
                <span className="mobile-inv-accordion-title">Payment</span>
                <span className="mobile-inv-accordion-chevron">
                  <svg
                    width="18" height="9" viewBox="0 0 18 9"
                    fill="none"
                    style={{ transform: paymentAccordionOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease' }}
                  >
                    <path d="M1.5 1.5L9 7.5L16.5 1.5" stroke="#405BFF" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
              </div>
              {paymentAccordionOpen && (
                <div className="mobile-inv-accordion-body">
                  {(!invoiceData || (invoiceData && invoiceData.inv_payment_status === 0)) && (
                    <div className="mobile-inv-payment-btns">
                      <button type="button" className="mobile-btn-pay" onClick={openPaymentModal}>
                        Pay Invoice
                      </button>
                      <button type="button" className="mobile-btn-process-manual" onClick={handleManualPayment}>
                        Process Manually
                      </button>
                    </div>
                  )}
                  <div className="mobile-inv-pay-detail-rows">
                    <div className="mobile-inv-detail-row-bordered">
                      <span className="mobile-inv-row-label">Payment App</span>
                      <span className="mobile-inv-row-val">
                        <img src={wiseImage} alt="Wise" style={{ height: "20px", display: "block" }} />
                      </span>
                    </div>
                    <div className="mobile-inv-detail-row-bordered">
                      <span className="mobile-inv-row-label">Company</span>
                      <span className="mobile-inv-row-val">{wxCompany || "WX Agency"}</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
            )}

            {/* Accordion 3: Recipient Details */}
            <div className="mobile-inv-card-accordion">
              <div
                className="mobile-inv-accordion-header"
                onClick={() => setRecipientAccordionOpen(!recipientAccordionOpen)}
              >
                <span className="mobile-inv-accordion-title">Recipient Details</span>
                <span className="mobile-inv-accordion-chevron">
                  <svg
                    width="18"
                    height="9"
                    viewBox="0 0 18 9"
                    fill="none"
                    style={{
                      transform: recipientAccordionOpen ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.2s ease",
                    }}
                  >
                    <path d="M1.5 1.5L9 7.5L16.5 1.5" stroke="#405BFF" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
              </div>
              {recipientAccordionOpen && (
                <div className="mobile-inv-accordion-body">
                  <div className="mobile-inv-pay-detail-rows">
                    <div className="mobile-inv-detail-row-bordered">
                      <span className="mobile-inv-row-label">Account Holder Name</span>
                      <span className="mobile-inv-row-val">
                        {bankDetails ? (
                          bankDetails.name?.fullName
                        ) : bankDetailsLoaded ? (
                          "—"
                        ) : (
                          <span
                            style={{
                              display: "inline-block",
                              width: "120px",
                              height: "16px",
                              backgroundColor: "#e5e7eb",
                              borderRadius: "4px",
                              animation: "pulse 1.5s ease-in-out infinite",
                            }}
                          />
                        )}
                      </span>
                    </div>
                    <div className="mobile-inv-detail-row-bordered">
                      <span className="mobile-inv-row-label">Currency</span>
                      <span className="mobile-inv-row-val">
                        {bankDetails ? (
                          bankDetails.currency
                        ) : bankDetailsLoaded ? (
                          "—"
                        ) : (
                          <span
                            style={{
                              display: "inline-block",
                              width: "40px",
                              height: "16px",
                              backgroundColor: "#e5e7eb",
                              borderRadius: "4px",
                              animation: "pulse 1.5s ease-in-out infinite",
                            }}
                          />
                        )}
                      </span>
                    </div>
                    <div className="mobile-inv-detail-row-bordered">
                      <span className="mobile-inv-row-label">Account IBAN Number</span>
                      <span className="mobile-inv-row-val">
                        {bankDetails ? (
                          bankDetails.accountSummary
                        ) : bankDetailsLoaded ? (
                          "—"
                        ) : (
                          <span
                            style={{
                              display: "inline-block",
                              width: "160px",
                              height: "16px",
                              backgroundColor: "#e5e7eb",
                              borderRadius: "4px",
                              animation: "pulse 1.5s ease-in-out infinite",
                            }}
                          />
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
            </div>
          </div>

          <div className="mobile-inv-body-content">
            {/* Metadata Card: Invoice ID, Type, Due Date, Issue Date */}
            <div className="mobile-inv-details-card">
              <div className="mobile-inv-detail-row">
                <span className="mobile-inv-row-label">Invoice ID</span>
                <span className="mobile-inv-row-val">{invoiceData ? invoiceData.inv_number : "—"}</span>
              </div>
              <div className="mobile-inv-detail-row">
                <span className="mobile-inv-row-label">Type</span>
                <span className="mobile-inv-row-val">{invoiceData ? invoiceData.inv_type : "Regular"}</span>
              </div>
              <div className="mobile-inv-detail-row">
                <span className="mobile-inv-row-label">Due Date</span>
                <span className="mobile-inv-row-val">
                  {invoiceData?.inv_due_date ? moment.tz(moment(invoiceData.inv_due_date).format("YYYY-MM-DD"), global.config.getTimeZone()).locale("en-gb").format("MM/DD/YY") : "—"}
                </span>
              </div>
              <div className="mobile-inv-detail-row">
                <span className="mobile-inv-row-label">Issue Date</span>
                <span className="mobile-inv-row-val">
                  {invoiceData?.inv_issue_date ? moment.tz(invoiceData.inv_issue_date, global.config.getTimeZone()).locale("en-gb").format("MM/DD/YY") : "—"}
                </span>
              </div>
            </div>

            {/* From Card */}
            <div className="mobile-inv-address-card">
              <div className="mobile-inv-section-title">From</div>
              <div className="mobile-inv-address-content">
                <div className="mobile-inv-name">
                  {invoiceData?.inv_for ? (
                    [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(invoiceData.inv_for.user_category)
                      ? invoiceData.inv_for.company_name
                      : `${String(invoiceData.inv_for.first_name) === "null" ? "" : invoiceData.inv_for.first_name} ${String(invoiceData.inv_for.middle_name) === "null" ? "" : invoiceData.inv_for.middle_name} ${String(invoiceData.inv_for.last_name) === "null" ? "" : invoiceData.inv_for.last_name}`
                  ) : "Calin Tatar"}
                </div>
                <div className="mobile-inv-address-text">
                  {invoiceData?.inv_for?.address || "Sat Ivanesti, Comuna Livezeni, str. Bozeni, nr 10, Mures, Romania, Ivanesti, RO"}
                </div>
                <div className="mobile-inv-address-text">
                  Tel: {invoiceData?.inv_for?.mobile_no || "40757620095"}
                </div>
                <div className="mobile-inv-address-text">
                  Email: {invoiceData?.inv_for?.email || "tatarcalin1@gmail.com"}
                </div>
              </div>
            </div>

            {/* To Card */}
            <div className="mobile-inv-address-card">
              <div className="mobile-inv-section-title">To</div>
              <div className="mobile-inv-address-content">
                <div className="mobile-inv-name">
                  {invoiceData?.companyDetails?.legal_entity_company_name || invoiceData?.companyDetails?.wx_company || "WebXpertos"}
                </div>
                <div className="mobile-inv-address-text">
                  {invoiceData?.companyDetails?.address ? Parser().parse(invoiceData.companyDetails.address) : "Calle 50, F&F Tower, 37th Floor Office D, Republic of Panama"}
                </div>
                <div className="mobile-inv-address-text">
                  Tel: {invoiceData?.companyDetails?.mobile_no || "+1 561 229 4778"}
                </div>
                <div className="mobile-inv-address-text">
                  Email: {invoiceData?.companyDetails?.email || "info@wx.agency"}
                </div>
              </div>
            </div>

            {/* Line Items Card */}
            <div className="mobile-inv-line-items-card">
              <div className="mobile-inv-section-title">Line Items</div>
              {invoiceView?.[0]?.Invoice_Details ? (
                invoiceView[0].Invoice_Details.map((item, idx) => {
                  const isExpanded = !!expandedLineItems[idx];
                  const currency = invoiceData?.inv_currency || invoiceView[0]?.inv_currency || "USD";
                  const isReimbursement = invoiceData?.inv_type === "Reimbursement" || invoiceView[0]?.inv_type === "Reimbursement";
                  return (
                    <div
                      className={`mobile-inv-line-item-block${isExpanded ? " is-open" : ""}`}
                      key={idx}
                    >
                      <button
                        type="button"
                        className="mobile-inv-line-item-row"
                        onClick={() =>
                          setExpandedLineItems((prev) => ({
                            ...prev,
                            [idx]: !prev[idx],
                          }))
                        }
                        aria-expanded={isExpanded}
                      >
                        <div className="mobile-inv-line-item-left">
                          <span className="mobile-inv-line-item-desc">{item.Description}</span>
                        </div>
                        <div className="mobile-inv-line-item-right">
                          <span className="mobile-inv-line-item-price">
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency,
                            }).format(item.Price)}
                          </span>
                          <svg
                            width="10"
                            height="6"
                            viewBox="0 0 10 6"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                              transition: "transform 0.2s ease",
                            }}
                          >
                            <path d="M1 1L5 5L9 1" stroke="#3B82F6" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </div>
                      </button>
                      {isExpanded && (
                        <div className="mobile-inv-line-item-dropdown">
                          <div className="mobile-inv-line-item-dropdown-head">
                            <span>{isReimbursement ? "Category" : "Cost"}</span>
                            <span>VAT %</span>
                          </div>
                          <div className="mobile-inv-line-item-dropdown-values">
                            <span>
                              {isReimbursement
                                ? (item.Category || "—")
                                : new Intl.NumberFormat("en-US", {
                                    style: "currency",
                                    currency,
                                  }).format(item.Cost ?? 0)}
                            </span>
                            <span>{item.VAT ?? 0}</span>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                <>
                  <div className="mobile-inv-line-item-block">
                    <div className="mobile-inv-line-item-row">
                      <div className="mobile-inv-line-item-left">
                        <span className="mobile-inv-line-item-desc">GR - Website analytics</span>
                      </div>
                      <div className="mobile-inv-line-item-right">
                        <span className="mobile-inv-line-item-price">$1,800.00</span>
                        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 1L5 5L9 1" stroke="#3B82F6" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="mobile-inv-line-item-block">
                    <div className="mobile-inv-line-item-row">
                      <div className="mobile-inv-line-item-left">
                        <span className="mobile-inv-line-item-desc">GR - Social media marketing</span>
                      </div>
                      <div className="mobile-inv-line-item-right">
                        <span className="mobile-inv-line-item-price">$1,800.00</span>
                        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 1L5 5L9 1" stroke="#3B82F6" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </>
              )}

              <div className="mobile-inv-summary-block">
                <div className="mobile-inv-summary-row">
                  <span>Subtotal</span>
                  <span>{invoiceData?.inv_sub_total ? new Intl.NumberFormat('en-US', { style: 'currency', currency: invoiceData?.inv_currency || 'USD' }).format(invoiceData.inv_sub_total[0]) : "$1,800.00"}</span>
                </div>
                <div className="mobile-inv-summary-row">
                  <span>VAT%</span>
                  <span>{invoiceData?.inv_total_tax || 0}</span>
                </div>
                <div className="mobile-inv-summary-row total-row">
                  <span>Invoice Total</span>
                  <span>{invoiceData?.inv_total_amount ? new Intl.NumberFormat('en-US', { style: 'currency', currency: invoiceData?.inv_currency || 'USD' }).format(invoiceData.inv_total_amount) : "$1,800.00"}</span>
                </div>
              </div>
            </div>

            {/* Other Comments Card */}
            <div className="mobile-inv-comments-card">
              <div className="mobile-inv-section-title">Other comments</div>
              <div className="mobile-inv-comment-text">
                {invoiceData?.inv_other_comments || "Comment is here."}
              </div>
            </div>

            {/* Attachments Card */}
            {invoiceData?.inv_file && invoiceData.inv_file.length > 0 && (
              <div className="mobile-inv-attachments-card">
                <div className="mobile-inv-section-title">Attachments</div>
                {Array.isArray(invoiceData.inv_file) ? (
                  invoiceData.inv_file.map((file, idx) => (
                    <div
                      className="mobile-inv-attachment-pill"
                      key={idx}
                      onClick={() => downloadInvDoc(file)}
                    >
                      <div className="mobile-attachment-info">
                        <span className="mobile-attachment-name">
                          {file.length > 20 ? `${file.slice(0, 20)}...` : file}
                        </span>
                        <span className="mobile-attachment-meta">
                          {getFileExtension(file)?.toUpperCase()} {invoiceData.inv_file_size?.[idx] ? `• ${invoiceData.inv_file_size[idx]}` : ""}
                        </span>
                      </div>
                      <div className="mobile-attachment-icon">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <path d="M7 1V13M7 13L1 7M7 13L13 7" stroke="#1E293B" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                    </div>
                  ))
                ) : (
                  <div
                    className="mobile-inv-attachment-pill"
                    onClick={() => downloadInvDoc(invoiceData.inv_file)}
                  >
                    <div className="mobile-attachment-info">
                      <span className="mobile-attachment-name">
                        {invoiceData.inv_file.length > 20 ? `${invoiceData.inv_file.slice(0, 20)}...` : invoiceData.inv_file}
                      </span>
                      <span className="mobile-attachment-meta">
                        {getFileExtension(invoiceData.inv_file)?.toUpperCase()} {invoiceData.inv_file_size ? `• ${invoiceData.inv_file_size}` : ""}
                      </span>
                    </div>
                    <div className="mobile-attachment-icon">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M7 1V13M7 13L1 7M7 13L13 7" stroke="#1E293B" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          {/* Options Bottom Sheet Modal */}
          <Modal
            className="mobile-action-modal"
            overlayClassName="mobile-sheet-overlay"
            isOpen={mobileOptionsModalOpen}
            onRequestClose={() => setMobileOptionsModalOpen(false)}
            closeTimeoutMS={480}
            style={{
              content: {
                position: "fixed",
                bottom: "0",
                top: "auto",
                left: "0",
                right: "0",
                width: "100%",
                maxWidth: "100%",
                borderRadius: "24px 24px 0 0",
                padding: "0 0 28px 0",
                border: "none",
                background: "#FFFFFF",
                transform: "none",
                inset: "auto 0px 0px 0px",
                zIndex: 1000,
              },
            }}
          >
            <div className="mobile-bottom-sheet-content">
              <div className="mobile-bottom-sheet-header">
                <button
                  type="button"
                  className="mobile-sheet-close-circle"
                  onClick={() => setMobileOptionsModalOpen(false)}
                >
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L11 11M1 11L11 1" stroke="#334155" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <h3 className="mobile-sheet-title">Options</h3>
              </div>
              <div className="mobile-options-list">
                {invoiceData && (invoiceData.inv_status === 0 || invoiceData.inv_status === "0") && invoiceData.is_automatic_inv === false && (
                  <div className="mobile-option-item" onClick={handleEditInvoice}>
                    <div className="mobile-option-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                        <path d="M18.9682 4.78909L14.6024 0.397477C14.5398 0.334479 14.4569 0.299877 14.3682 0.299879C14.2796 0.299882 14.1971 0.334489 14.1345 0.39749L11.5479 2.99961L11.5449 3.00892L11.4933 3.05462L1.50304 13.105C1.45673 13.1516 1.42542 13.2102 1.41263 13.2741L0.306705 18.7794C0.284657 18.889 0.31862 19.0013 0.397124 19.0807C0.459751 19.1432 0.542665 19.1778 0.631311 19.1778C0.653362 19.1778 0.674972 19.1756 0.695259 19.1716L6.16878 18.0583C6.23316 18.0455 6.29094 18.014 6.3368 17.9678L18.9682 5.25981C19.0309 5.19726 19.0648 5.1134 19.0648 5.02423C19.0648 4.93505 19.0304 4.85165 18.9682 4.78909ZM5.93898 17.4261L1.05335 18.4201L2.04066 13.5048L3.48276 12.054L7.38109 15.9758L5.93898 17.4261ZM7.84856 15.505L3.95023 11.5837L11.7336 3.75337L15.6315 7.67473L7.84812 15.505L7.84856 15.505ZM16.0999 7.204L12.202 3.28264L14.3682 1.10334L18.2666 5.0247L16.0999 7.204Z" fill="#282828" stroke="#282828" strokeWidth="0.6"/>
                      </svg>
                    </div>
                    <span className="mobile-option-text">Edit Invoice</span>
                  </div>
                )}

                <div
                  className="mobile-option-item"
                  onClick={handleDownloadPdf}
                  style={{ opacity: isCreatingPdf ? 0.6 : 1, pointerEvents: isCreatingPdf ? 'none' : 'auto' }}
                >
                  <div className="mobile-option-icon">
                    {isCreatingPdf ? (
                      <span className="inv-btn-dots"><span /><span /><span /></span>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16" fill="none" aria-hidden="true">
                        <path d="M5.77625 15.1039C5.80157 15.1271 5.82923 15.1479 5.85884 15.1661L5.90014 15.1861L5.95235 15.2121L6.00689 15.2282L6.05482 15.2404C6.12651 15.2543 6.20092 15.2543 6.273 15.2404L6.32092 15.2282L6.37547 15.2121L6.42767 15.1861L6.46897 15.1661C6.49897 15.1479 6.52664 15.1271 6.55196 15.1039L11.9477 10.15C12.1273 9.95143 12.1125 9.66 11.9134 9.4775C11.7143 9.295 11.3964 9.28143 11.1798 9.44607L6.70702 13.55V0.75C6.70702 0.473929 6.46274 0.25 6.16157 0.25C5.8604 0.25 5.61612 0.473929 5.61612 0.75V13.55L1.14339 9.44607C0.926765 9.28143 0.608843 9.295 0.409752 9.4775C0.210661 9.66 0.195856 9.95143 0.375466 10.15L5.77547 15.1039H5.77625Z" fill="#282828" stroke="#282828" strokeWidth="0.5"/>
                      </svg>
                    )}
                  </div>
                  <span className="mobile-option-text">{isCreatingPdf ? "Downloading..." : "Download"}</span>
                </div>

                {invoiceData?.inv_payment_status === 0 && (
                  <div className="mobile-option-item" onClick={handleDeleteInvoiceMobile}>
                    <div className="mobile-option-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none" aria-hidden="true">
                        <path d="M16.2076 18.8943L16.6862 3.62739H18.827V3.10185H13.2607V1.70917C13.2607 0.947142 12.6814 0.342773 11.951 0.342773H7.21587C6.48545 0.342773 5.90615 0.947142 5.90615 1.70917V3.10185H0.339844V3.62739H2.48073L2.95928 18.8943C2.98447 19.6037 3.53858 20.1556 4.21863 20.1556H14.9231C15.6283 20.1556 16.1824 19.6037 16.2076 18.8943ZM6.40989 1.70917C6.40989 1.23619 6.76251 0.868311 7.21587 0.868311H11.951C12.4044 0.868311 12.757 1.23619 12.757 1.70917V3.10185H6.40989V1.70917ZM3.46302 18.868L2.98447 3.62739H16.1824L15.7039 18.868C15.6787 19.2884 15.3512 19.63 14.9483 19.63H4.21863C3.81564 19.63 3.48821 19.2884 3.46302 18.868Z" fill="#282828" stroke="#282828" strokeWidth="0.5"/>
                        <path d="M14.9236 20.25H4.21874C3.48877 20.25 2.89643 19.6564 2.86944 18.8986L2.39359 3.7223H0.25V3.00907H5.81631V1.71024C5.81631 0.891438 6.43114 0.25 7.21598 0.25H11.9511C12.736 0.25 13.3508 0.891438 13.3508 1.71024V3.00907H18.9171V3.7223H16.7731L16.3004 18.8015H16.3008L16.2972 18.8986C16.2702 19.6564 15.6666 20.25 14.9232 20.25H14.9236ZM0.429907 3.53414H2.5681L3.04935 18.8916C3.07273 19.5476 3.58637 20.0618 4.21874 20.0618H14.9236C15.5767 20.0618 16.0876 19.5649 16.1173 18.9038V18.8916L16.599 3.53414H18.7372V3.1963H13.1709V1.70978C13.1709 0.996076 12.6352 0.437223 11.9511 0.437223H7.21598C6.53189 0.437223 5.99622 0.996076 5.99622 1.70978V3.1963H0.429907V3.53414ZM4.21874 19.7245C3.77347 19.7245 3.40196 19.351 3.37363 18.8742V18.8714L2.89193 3.53367H16.2756L15.7939 18.8714C15.7651 19.351 15.3941 19.724 14.9484 19.724H4.21874V19.7245ZM3.55308 18.8639C3.57647 19.2412 3.86837 19.5368 4.21874 19.5368H14.9484C15.2992 19.5368 15.5915 19.2407 15.614 18.8625L16.0894 3.72137H3.07723L3.55263 18.8634L3.55308 18.8639ZM12.8471 3.1963H6.32005V1.70978C6.32005 1.18565 6.71359 0.775069 7.21598 0.775069H11.9511C12.4535 0.775069 12.8471 1.18565 12.8471 1.70978V3.1963ZM6.49995 3.0086H12.6672V1.70978C12.6672 1.29075 12.3528 0.962761 11.9511 0.962761H7.21598C6.81434 0.962761 6.49995 1.29075 6.49995 1.70978V3.0086Z" fill="#282828" stroke="#282828" strokeWidth="0.5"/>
                        <path d="M9.33081 7.62158H9.83455V15.4784H9.33081V7.62158Z" fill="#282828" stroke="#282828" strokeWidth="0.5"/>
                        <path d="M9.92461 15.5723H9.24097V7.52783H9.92461V15.5723ZM9.42087 15.3846H9.74471V7.71552H9.42087V15.3846Z" fill="#282828" stroke="#282828" strokeWidth="0.5"/>
                        <path d="M6.30884 7.62158H6.81258V15.4784H6.30884V7.62158Z" fill="#282828" stroke="#282828" strokeWidth="0.5"/>
                        <path d="M6.90239 15.5723H6.21875V7.52783H6.90239V15.5723ZM6.39866 15.3846H6.72249V7.71552H6.39866V15.3846Z" fill="#282828" stroke="#282828" strokeWidth="0.5"/>
                        <path d="M12.3547 7.62158H12.8585V15.4784H12.3547V7.62158Z" fill="#282828" stroke="#282828" strokeWidth="0.5"/>
                        <path d="M12.9483 15.5723H12.2646V7.52783H12.9483V15.5723ZM12.4446 15.3846H12.7684V7.71552H12.4446V15.3846Z" fill="#282828" stroke="#282828" strokeWidth="0.5"/>
                      </svg>
                    </div>
                    <span className="mobile-option-text">Delete</span>
                  </div>
                )}
              </div>
            </div>
          </Modal>

          {/* Mobile Delete Confirmation Modal */}
          <Modal
            className="mobile-action-modal"
            overlayClassName="mobile-sheet-overlay"
            isOpen={deleteModalIsOpen}
            onRequestClose={!isSubmitLoading ? () => setDeleteModalIsOpen(false) : undefined}
            contentLabel="Confirm Deletion"
            closeTimeoutMS={480}
            style={{
              content: {
                position: "fixed",
                bottom: "0",
                top: "auto",
                left: "0",
                right: "0",
                width: "100%",
                maxWidth: "100%",
                borderRadius: "24px 24px 0 0",
                padding: "0 0 28px 0",
                border: "none",
                background: "#FFFFFF",
                transform: "none",
                inset: "auto 0px 0px 0px",
                zIndex: 1001,
              },
            }}
          >
            <div className="mobile-bottom-sheet-content">
              <div className="mobile-bottom-sheet-header">
                <button
                  type="button"
                  className="mobile-sheet-close-circle"
                  onClick={() => setDeleteModalIsOpen(false)}
                  disabled={isSubmitLoading}
                >
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L11 11M1 11L11 1" stroke="#334155" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <h3 className="mobile-sheet-title">Delete Invoice</h3>
              </div>
              <div className="mobile-sheet-body" style={{ padding: '20px 24px 0 24px', textAlign: 'center' }}>
                <p className="mobile-sheet-msg" style={{ fontSize: '16px', color: '#475569', marginBottom: '24px', lineHeight: '1.5' }}>
                  Are you sure you want to <strong>delete</strong><br />this invoice?
                </p>
                <div className="mobile-sheet-btns" style={{ display: 'flex', gap: '12px' }}>
                  <button
                    type="button"
                    className="mobile-btn-sheet-reject"
                    onClick={handleModalConfirm}
                    disabled={isSubmitLoading}
                    style={{ flex: 1, height: '48px', borderRadius: '12px', background: '#EF4444', color: '#FFFFFF', fontWeight: '600', border: 'none', cursor: 'pointer' }}
                  >
                    {isSubmitLoading ? "Deleting..." : "Delete"}
                  </button>
                  <button
                    type="button"
                    className="mobile-btn-sheet-cancel"
                    onClick={() => setDeleteModalIsOpen(false)}
                    disabled={isSubmitLoading}
                    style={{ flex: 1, height: '48px', borderRadius: '12px', background: '#F1F5F9', color: '#475569', fontWeight: '600', border: 'none', cursor: 'pointer' }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      ) : (
        <>
          <div className="back-btn-ins">
            <Link to="/user/invoices" className="btnf1-si-s">
              Back to All Invoices
            </Link>
          </div>
          <InvoiceActions
            invoiceData={invoiceData}
            invoiceView={invoiceView}
            componentRef={componentRef}
          />
          <div className="man-padd-for-siginvo">
            <div className="invoice-main-body">
          <div className="invoice-detail-bs1" ref={componentRef}>
            <div className="main-head-bs11">
              <div className="invoce-id-num">
                <div className="invo-id">Invoice ID </div>
                <div className="invo-num-1">
                  {invoiceData ? (
                    invoiceData.inv_number
                  ) : (
                    <div
                      style={{
                        width: "100px",
                        height: "18px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "4px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="invoce-id-type">
                <div className="invo-id">Type</div>
                <div className="invo-num-1">
                  {invoiceData ? (
                    invoiceData.inv_type
                  ) : (
                    <div
                      style={{
                        width: "80px",
                        height: "18px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "4px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="invoce-id-exdate">
                <div className="invo-id">Due Date</div>
                <div className="invo-num-1">
                  {invoiceData ? (

                    moment.tz(moment(invoiceData.inv_due_date).format("YYYY-MM-DD"), global.config.getTimeZone()).locale("en-gb").format("DD/MM/YYYY")
                  ) : (
                    <div
                      style={{
                        width: "90px",
                        height: "18px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "4px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="invoce-id-isdate">
                <div className="invo-id">Issue Date </div>
                <div className="invo-num-1">
                  {invoiceData ? (

                    moment.tz(invoiceData.inv_issue_date, global.config.getTimeZone()).locale("en-gb").format("DD/MM/YYYY")
                  ) : (
                    <div
                      style={{
                        width: "90px",
                        height: "18px",
                        backgroundColor: "#e5e7eb",
                        borderRadius: "4px",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  )}
                </div>
              </div>
            </div>

            <div className="head-con-date">
              {invoiceData ? (
                invoiceData.inv_title
              ) : (
                <div
                  style={{
                    width: "200px",
                    height: "23px",
                    backgroundColor: "#e5e7eb",
                    borderRadius: "4px",
                    animation: "pulse 1.5s ease-in-out infinite",
                  }}
                />
              )}
            </div>

            {/* invoice from to */}
            <InvoiceAddress
              invoiceData={invoiceData ? invoiceData.inv_for : null}
              invoiceCompanyDetails={invoiceData ? invoiceData.companyDetails : null}
              Company={invoiceData ? invoiceData.inv_bank_profile : null}
              invCompany={invoiceData ? invoiceData.inv_company_name : null}
            />
            <div className="table-outtter">
              <ItemDescription invoiceData={invoiceView?.length ? invoiceView : null} />
              <div className="other-comment">
                {invoiceData && invoiceData.inv_other_comments && (
                  <>
                    <div className="other-head1">Other comments</div>
                    <div className="other-subhead1">
                      {" "}
                      {invoiceData.inv_other_comments}
                    </div>
                  </>
                )}
              </div>
              {invoiceData && invoiceData.inv_file && invoiceData.inv_file.length > 0 && (
                <div className="attachment-single-invi">
                  <div className="attachment-head">Attachments</div>
                  {Array.isArray(invoiceData.inv_file) ? (
                    invoiceData.inv_file.map((file, index) => (
                      <div
                        className="the-src-pdf-file"
                        onClick={() => downloadInvDoc(file)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="bottom-download-outer">
                          <div className="bottom-download-inner">
                            <div key={index} className="bottom-download-item">
                              <div
                                className="attachment-file-sib-pname"
                              >
                                {file.length > 15 ? (
                                  <span className="shortened-name" title={file}>
                                    {file.slice(0, 15)}...
                                  </span>
                                ) : (
                                  file
                                )}
                              </div>
                              <div className="attachment-file-sib-psize">
                                {file && getFileExtension(file)?.toUpperCase()}{" "}
                                {invoiceData.inv_file_size && invoiceData.inv_file_size[index] && (
                                  <span>{invoiceData.inv_file_size[index]}</span>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="bottom-download-inner-right">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15" fill="none">
                              <path d="M5.67409 13.8727C5.69551 13.8928 5.71891 13.9108 5.74395 13.9266L5.77888 13.9439L5.82304 13.9665L5.86918 13.9804L5.90971 13.9909C5.97034 14.003 6.03328 14.003 6.09425 13.9909L6.13478 13.9804L6.18091 13.9665L6.22507 13.9439L6.26 13.9266C6.28537 13.9108 6.30877 13.8928 6.33019 13.8727L10.8939 9.57954C11.0458 9.40745 11.0333 9.1549 10.8649 8.99674C10.6965 8.83858 10.4276 8.82682 10.2444 8.9695L6.46134 12.526V1.43331C6.46134 1.19406 6.25473 1 6 1C5.74527 1 5.53865 1.19406 5.53865 1.43331V12.526L1.75563 8.9695C1.57241 8.82682 1.30351 8.83858 1.13512 8.99674C0.966727 9.1549 0.954205 9.40745 1.10612 9.57954L5.67343 13.8727H5.67409Z" fill="#282828" stroke="#282828" strokeWidth="0.5" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div
                      className="the-src-pdf-file"
                      onClick={() => downloadInvDoc(invoiceData.inv_file)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="bottom-download-inner">
                        <div className="bottom-download-item">
                          <div
                            className="attachment-file-sib-pname"
                          >
                            {invoiceData.inv_file.length > 15 ? (
                              <span className="shortened-name" title={invoiceData.inv_file}>
                                {invoiceData.inv_file.slice(0, 15)}...
                              </span>
                            ) : (
                              invoiceData.inv_file
                            )}
                          </div>
                          <div className="attachment-file-sib-psize">
                            {invoiceData.inv_file && getFileExtension(invoiceData.inv_file)?.toUpperCase()}{" "}
                            {invoiceData.inv_file_size && (
                              <span>{invoiceData.inv_file_size}</span>
                            )}
                          </div>
                          <div className="bottom-download-inner-right">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15" fill="none">
                              <path d="M5.67409 13.8727C5.69551 13.8928 5.71891 13.9108 5.74395 13.9266L5.77888 13.9439L5.82304 13.9665L5.86918 13.9804L5.90971 13.9909C5.97034 14.003 6.03328 14.003 6.09425 13.9909L6.13478 13.9804L6.18091 13.9665L6.22507 13.9439L6.26 13.9266C6.28537 13.9108 6.30877 13.8928 6.33019 13.8727L10.8939 9.57954C11.0458 9.40745 11.0333 9.1549 10.8649 8.99674C10.6965 8.83858 10.4276 8.82682 10.2444 8.9695L6.46134 12.526V1.43331C6.46134 1.19406 6.25473 1 6 1C5.74527 1 5.53865 1.19406 5.53865 1.43331V12.526L1.75563 8.9695C1.57241 8.82682 1.30351 8.83858 1.13512 8.99674C0.966727 9.1549 0.954205 9.40745 1.10612 9.57954L5.67343 13.8727H5.67409Z" fill="#282828" stroke="#282828" strokeWidth="0.5" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="manage-detail-outer">
            <div className="manage-detail-bs2">
              <div className="invoice-manage-singlepg-head">Manage invoice</div>
              <div className="single-invo-sattus">
                <div className="invo-main-status-head">Invoice Status</div>
                <div className="invo-sig-st-btns">
                  {user && (user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN) ? (
                    invoiceData ? (
                      invoiceData.inv_payment_status ===
                        INVOICE_STATUS.INVOICE_PAYMENT_NOT_PROCESSING ? (
                        <>
                          {invStatus === "Approved" ||
                            invoiceData.inv_status ===
                            INVOICE_STATUS.INVOICE_APPROVE ? (
                            <>
                              <Link className="Approve-singlebtn approved">
                                Approved <TikIcon />
                              </Link>
                              <Link
                                className="Reject-singlebtn"
                                onClick={openRejectModal}
                              >
                                {" "}
                                Reject <CrssrIcon />{" "}
                              </Link>
                            </>
                          ) : invStatus === "Rejected" ||
                            invoiceData.inv_status ===
                            INVOICE_STATUS.INVOICE_REJECT ? (
                            <>
                              <Link
                                className="Approve-singlebtn"
                                onClick={openModal}
                              >
                                {" "}
                                Approve <TikIcon />{" "}
                              </Link>
                              <Link className="Reject-singlebtn rejected">
                                Rejected <CrssrIcon />
                              </Link>
                            </>
                          ) : invoiceData.inv_status ===
                            INVOICE_STATUS.INVOICE_CANCEL ||
                            invStatus === "Cancelled" ? (
                            <Link
                              className="Approve-singlebtn"
                              onClick={openModal}
                            >
                              {" "}
                              Cancelled <TikIcon />{" "}
                            </Link>
                          ) : invoiceData.inv_status ===
                            INVOICE_STATUS.INVOICE_PENDING ? (
                            <>
                              <Link
                                className="Approve-singlebtn"
                                onClick={openModal}
                              >
                                {" "}
                                Approve <TikIcon />{" "}
                              </Link>
                              <Link
                                className="Reject-singlebtn"
                                onClick={openRejectModal}
                              >
                                {" "}
                                Reject <CrssrIcon />{" "}
                              </Link>
                            </>
                          ) : null}
                        </>
                      ) : (

                        <PaymentStatusWiseSingle
                          inv_payment_details={invoiceData._id}
                          invData={invoiceData}
                        />
                      )
                    ) : (
                      <div className="invo-sig-st-btns">
                        <div
                          style={{
                            height: "44px",
                            backgroundColor: "#e5e7eb",
                            border: "1px solid rgba(106, 121, 136, 0.3)",
                            borderRadius: "8px",
                            animation: "pulse 1.5s ease-in-out infinite",
                          }}
                        />
                        <div
                          style={{
                            height: "44px",
                            backgroundColor: "#e5e7eb",
                            border: "1px solid rgba(106, 121, 136, 0.3)",
                            borderRadius: "8px",
                            animation: "pulse 1.5s ease-in-out infinite",
                            marginTop: "10px",
                          }}
                        />
                      </div>
                    )
                  ) : invoiceData &&
                    invoiceData.inv_payment_status ===
                    INVOICE_STATUS.INVOICE_PAYMENT_NOT_PROCESSING ? (
                    invoiceData &&
                    (invoiceData.inv_status === INVOICE_STATUS.INVOICE_PENDING ? (
                      <Link className="NotReviewed-singlebtn  Notreviewed ">
                        {" "}
                        Not Reviewed{" "}
                      </Link>
                    ) : invoiceData.inv_status ===
                      INVOICE_STATUS.INVOICE_PAYMENT_PROCESSING ? (
                      <Link className="Approve-singlebtn approved">
                        Approved <TikIcon />
                      </Link>
                    ) : invoiceData.inv_status ===
                      INVOICE_STATUS.INVOICE_REJECT ? (
                      <a className="Reject-singlebtn rejected">
                        Rejected <CrssrIcon />
                      </a>
                    ) : invoiceData.inv_status ===
                      INVOICE_STATUS.INVOICE_CANCEL ? (
                      <a className="Approve-singlebtn" onClick={openModal}>
                        {" "}
                        Cancelled <TikIcon />{" "}
                      </a>
                    ) : (
                      ""
                    ))
                  ) : invoiceData &&
                    invoiceData.inv_payment_status ===
                    INVOICE_STATUS.INVOICE_PAYMENT_PROCESSING ? (
                    <Link className="Approve-singlebtn">
                      {" "}
                      Paid <TikIcon />{" "}
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="invo-sig-st-btns1" style={{ paddingTop: '20px' }}>
                {user &&
                  (user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN) &&
                  invoiceData &&
                  invoiceData.inv_payment_status === 0 && (
                    <>
                      {invoiceData.inv_status === 1 && (
                        <>
                          <div className="payment-btn-sec-head">Payment </div>
                          <div className="invo-sig-st-btns">
                            <Link
                              className="payin-singlebtn"
                              onClick={openPaymentModal}
                            >
                              Pay Invoice
                            </Link>
                            <Link
                              className="prma-singlebtn"
                              onClick={handleManualPayment}
                            >
                              {" "}
                              Process Manually
                            </Link>
                          </div>
                        </>
                      )}
                    </>
                  )}
              </div>
              <div className="payment-comp-detail">
                <div className="pay-app-det2">
                  <span className="head-payapp">Payment App</span>
                  <img src={wiseImage} alt="Edit Icon" />
                </div>
                <div className="company-detail">
                  <span className="head-payapp">Company</span>
                  <span className="companynae-sig">
                    {wxCompany}
                  </span>
                </div>
              </div>


            </div>
            <div className="manage-detail-bs2">
              <div className="invoice-manage-singlepg-head">Recipient Details</div>
              <div className="company-detail">
                <div className="head-payapp">Account Holder Name</div>
                <div className="companynae-sig">{bankDetails ? bankDetails.name.fullName : bankDetailsLoaded ? "—" : (
                  <div
                    style={{
                      width: "150px",
                      height: "18px",
                      backgroundColor: "#e5e7eb",
                      borderRadius: "4px",
                      animation: "pulse 1.5s ease-in-out infinite",
                    }}
                  />
                )}</div>
              </div>
              <div className="company-detail">
                <div className="head-payapp">Currency</div>
                <div className="companynae-sig">{bankDetails ? bankDetails.currency : bankDetailsLoaded ? "—" : (
                  <div
                    style={{
                      width: "50px",
                      height: "18px",
                      backgroundColor: "#e5e7eb",
                      borderRadius: "4px",
                      animation: "pulse 1.5s ease-in-out infinite",
                    }}
                  />
                )}</div>
              </div>
              <div className="company-detail">
                <div className="head-payapp">Account IBAN Number </div>
                <div className="companynae-sig">{bankDetails ? bankDetails.accountSummary : bankDetailsLoaded ? "—" : (
                  <div
                    style={{
                      width: "200px",
                      height: "18px",
                      backgroundColor: "#e5e7eb",
                      borderRadius: "4px",
                      animation: "pulse 1.5s ease-in-out infinite",
                    }}
                  />
                )}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )}

      {/* modal approve */}
      <Modal
        className={isMobile ? "mobile-action-modal" : "delete-modal"}
        overlayClassName={isMobile ? "mobile-sheet-overlay" : undefined}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Approve Modal"
        closeTimeoutMS={480}
        style={{
          content: isMobile ? {
            position: "fixed",
            bottom: "0",
            top: "auto",
            left: "0",
            right: "0",
            width: "100%",
            maxWidth: "100%",
            borderRadius: "24px 24px 0 0",
            padding: "0 0 28px 0",
            border: "none",
            background: "#FFFFFF",
            transform: "none",
            inset: "auto 0px 0px 0px",
          } : {
            height: "41%",
            width: "30%",
            position: "fixed",
            top: "40%",
            left: "50%",
          },
        }}
      >
        {isMobile ? (
          <div className="mobile-bottom-sheet-content">
            <div className="mobile-bottom-sheet-header">
              <button type="button" className="mobile-sheet-close-circle" onClick={closeModal}>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L11 11M1 11L11 1" stroke="#334155" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <h3 className="mobile-sheet-title">Approve Invoice</h3>
            </div>
            <div className="mobile-sheet-body">
              <p className="mobile-sheet-msg">
                Are you sure you want to <strong>approve</strong><br />this invoice?
              </p>
              <div className="mobile-sheet-btns">
                <button
                  className="mobile-btn-sheet-approve"
                  onClick={() => invoiceStatusApprove(true)}
                  disabled={isLoadingApprove || !invBank}
                >
                  {isLoadingApprove ? <span className="inv-btn-dots"><span /><span /><span /></span> : "Approve"}
                </button>
                <button className="mobile-btn-sheet-cancel" onClick={closeModal} disabled={isLoadingApprove}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="delete-modal-content">
            <div className="outter-modal-main">
              <a className="close-image-clr1" onClick={closeModal}>
                <CrssrIcon />
              </a>
            </div>
            <h2>Approve Invoice</h2>
            <p>Are you sure you want to Approve this Invoice</p>
            <div className="delete-modal-buttons">
              <button
                className="buttons-approved"
                onClick={() => invoiceStatusApprove(true)}
                disabled={isLoadingApprove || !invBank}
                style={{ minWidth: "100px", display: "inline-flex", alignItems: "center", justifyContent: "center" }}
              >
                {isLoadingApprove ? <span className="inv-btn-dots"><span /><span /><span /></span> : "Approve"}
              </button>
              <button onClick={closeModal} disabled={isLoadingApprove}>Cancel</button>
            </div>
          </div>
        )}
      </Modal>

      {/* modal reject */}
      <Modal
        className={isMobile ? "mobile-action-modal" : "delete-modal"}
        overlayClassName={isMobile ? "mobile-sheet-overlay" : undefined}
        isOpen={modalRejectIsOpen}
        onRequestClose={closeRejectModal}
        contentLabel="Reject Modal"
        closeTimeoutMS={480}
        style={{
          content: isMobile ? {
            position: "fixed",
            bottom: "0",
            top: "auto",
            left: "0",
            right: "0",
            width: "100%",
            maxWidth: "100%",
            borderRadius: "24px 24px 0 0",
            padding: "0 0 28px 0",
            border: "none",
            background: "#FFFFFF",
            transform: "none",
            inset: "auto 0px 0px 0px",
          } : {
            height: "41%",
            width: "30%",
            position: "fixed",
            top: "40%",
            left: "50%",
          },
        }}
      >
        {isMobile ? (
          <div className="mobile-bottom-sheet-content">
            <div className="mobile-bottom-sheet-header">
              <button type="button" className="mobile-sheet-close-circle" onClick={closeRejectModal}>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L11 11M1 11L11 1" stroke="#334155" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <h3 className="mobile-sheet-title">Reject Invoice</h3>
            </div>
            <div className="mobile-sheet-body">
              <p className="mobile-sheet-msg">
                Are you sure you want to <strong>reject</strong><br />this invoice?
              </p>
              <div className="mobile-sheet-btns">
                <button
                  className="mobile-btn-sheet-reject"
                  onClick={() => invoiceStatusReject()}
                  disabled={isLoadingReject}
                >
                  {isLoadingReject ? <span className="inv-btn-dots"><span /><span /><span /></span> : "Reject"}
                </button>
                <button className="mobile-btn-sheet-cancel" onClick={closeRejectModal} disabled={isLoadingReject}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="delete-modal-content">
            <div className="outter-modal-main">
              <a className="close-image-clr1" onClick={closeRejectModal}>
                <CrssrIcon />
              </a>
            </div>
            <h2>Reject Invoice</h2>
            <p>Are you sure you want to Reject this Invoice</p>
            <div className="delete-modal-buttons-reject">
              <button
                className="buttons-rejected"
                onClick={() => invoiceStatusReject()}
                disabled={isLoadingReject}
                style={{ minWidth: "100px", display: "inline-flex", alignItems: "center", justifyContent: "center" }}
              >
                {isLoadingReject ? <span className="inv-btn-dots"><span /><span /><span /></span> : "Reject"}
              </button>
              <button onClick={closeRejectModal} disabled={isLoadingReject}>Cancel</button>
            </div>
          </div>
        )}
      </Modal>

      {/* manual payment modal */}
      <Modal
        className={isMobile ? "mobile-action-modal" : "delete-modal"}
        overlayClassName={isMobile ? "mobile-sheet-overlay" : undefined}
        isOpen={manualModalIsOpen}
        onRequestClose={handleManualModalCancel}
        contentLabel="Manual Payment"
        closeTimeoutMS={480}
        style={{
          content: isMobile ? {
            position: "fixed",
            bottom: "0",
            top: "auto",
            left: "0",
            right: "0",
            width: "100%",
            maxWidth: "100%",
            borderRadius: "24px 24px 0 0",
            padding: "0 0 28px 0",
            border: "none",
            background: "#FFFFFF",
            transform: "none",
            inset: "auto 0px 0px 0px",
          } : {
            height: "41%",
            width: "30%",
            position: "fixed",
            top: "40%",
            left: "50%",
          },
        }}
      >
        {isMobile ? (
          <div className="mobile-bottom-sheet-content">
            <div className="mobile-bottom-sheet-header">
              <button type="button" className="mobile-sheet-close-circle" onClick={handleManualModalCancel}>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L11 11M1 11L11 1" stroke="#334155" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <h3 className="mobile-sheet-title">Manual Payment</h3>
            </div>
            <div className="mobile-sheet-body">
              <p className="mobile-sheet-msg">
                Are you sure you want to <strong>pay</strong> this<br />invoice <strong>manually</strong>?
              </p>
              <div className="mobile-sheet-btns">
                {invoiceData && (
                  <button
                    className="mobile-btn-sheet-primary"
                    onClick={() => handleManualModalConfirm(invoiceData._id)}
                    disabled={isLoadingManualPayment}
                  >
                    {isLoadingManualPayment ? <span className="inv-btn-dots"><span /><span /><span /></span> : "Pay Manually"}
                  </button>
                )}
                <button className="mobile-btn-sheet-cancel" onClick={handleManualModalCancel} disabled={isLoadingManualPayment}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="delete-modal-content">
            <div className="outter-modal-main">
              <a className="close-image-clr1" onClick={handleManualModalCancel}>
                <CrssrIcon />
              </a>
            </div>
            <h2>Manual Payment</h2>
            <p>Are you sure you want to Pay this Invoice Manually?</p>
            <div className="delete-modal-buttons">
              {invoiceData && (
                <button
                  className="buttons-pay"
                  onClick={() => handleManualModalConfirm(invoiceData._id)}
                  disabled={isLoadingManualPayment}
                  style={{ minWidth: "100px", display: "inline-flex", alignItems: "center", justifyContent: "center" }}
                >
                  {isLoadingManualPayment ? <span className="inv-btn-dots"><span /><span /><span /></span> : "Pay"}
                </button>
              )}
              <button onClick={handleManualModalCancel} disabled={isLoadingManualPayment}>Cancel</button>
            </div>
          </div>
        )}
      </Modal>

      {/* payment modal */}
      <Modal
        className={isMobile ? "mobile-action-modal" : "delete-modal"}
        overlayClassName={isMobile ? "mobile-sheet-overlay" : undefined}
        isOpen={showPaymentModal}
        onRequestClose={closePaymentModal}
        contentLabel="Payment"
        closeTimeoutMS={480}
        style={{
          content: isMobile ? {
            position: "fixed",
            bottom: "0",
            top: "auto",
            left: "0",
            right: "0",
            width: "100%",
            maxWidth: "100%",
            borderRadius: "24px 24px 0 0",
            padding: "0 0 28px 0",
            border: "none",
            background: "#FFFFFF",
            transform: "none",
            inset: "auto 0px 0px 0px",
          } : {
            height: "41%",
            width: "30%",
            position: "fixed",
            top: "40%",
            left: "50%",
          },
        }}
      >
        {isMobile ? (
          <div className="mobile-bottom-sheet-content">
            <div className="mobile-bottom-sheet-header">
              <button type="button" className="mobile-sheet-close-circle" onClick={closePaymentModal}>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L11 11M1 11L11 1" stroke="#334155" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <h3 className="mobile-sheet-title">Payment</h3>
            </div>
            <div className="mobile-sheet-body">
              <p className="mobile-sheet-msg">
                Are you sure you want to pay this invoice?
              </p>
              <div className="mobile-sheet-btns">
                {invoiceData && wiseSelected && invBank ? (
                  <button
                    className="mobile-btn-sheet-primary"
                    onClick={() => {
                      makePayment(
                        invoiceData.inv_currency,
                        invoiceData.inv_currency,
                        invoiceData.inv_total_amount,
                        wiseSelected,
                        invoiceData.inv_bank,
                        invoiceData._id,
                        wxCompany
                      );
                    }}
                    disabled={isLoadingPayment}
                  >
                    {isLoadingPayment ? <span className="inv-btn-dots"><span /><span /><span /></span> : "Pay"}
                  </button>
                ) : (
                  <button className="mobile-btn-sheet-primary mobile-btn-disabled" disabled>
                    Pay
                  </button>
                )}
                <button className="mobile-btn-sheet-cancel" onClick={closePaymentModal} disabled={isLoadingPayment}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="delete-modal-content">
            <div className="outter-modal-main">
              <a className="close-image-clr1" onClick={closePaymentModal}>
                <CrssrIcon />
              </a>
            </div>
            <h2>Payment</h2>
            <p>Are you sure you want to Pay this Invoice?</p>
            {isLoadingPayment ? (
              <div className="delete-modal-buttons paynow-invoice-sec">
                <button
                  className="buttons-pay"
                  disabled
                  style={{ minWidth: "100px", display: "inline-flex", alignItems: "center", justifyContent: "center" }}
                >
                  <span className="inv-btn-dots"><span /><span /><span /></span>
                </button>
                <button disabled>Cancel</button>
              </div>
            ) : (
              <div className="delete-modal-buttons paynow-invoice-sec">
                {invoiceData && wiseSelected && invBank ? (
                  <button
                    className="buttons-pay"
                    onClick={() => {
                      makePayment(
                        invoiceData.inv_currency,
                        invoiceData.inv_currency,
                        invoiceData.inv_total_amount,
                        wiseSelected,
                        invoiceData.inv_bank,
                        invoiceData._id,
                        wxCompany
                      );
                    }}
                    disabled={isLoadingPayment}
                  >
                    Pay
                  </button>
                ) : (
                  <button className="buttons-pay buttons-pay-disabled" disabled>
                    Pay
                  </button>
                )}
                <button className="buttons-pay-cancel" onClick={closePaymentModal}>
                  Cancel
                </button>
              </div>
            )}
          </div>
        )}
      </Modal>
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  );
};

export default InvoiceSingle;